<template src='./clientModal.pug' lang='pug'></template>

<script>
import Modal from '../modal/Modal'
import customSorter from '../../../utils/customSorter.js'
import PATHS from '../../../router/routesMap.js'

export default {
  name: 'ClientModal',

  components: {
    Modal
  },

  props: {
    autoOpen: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      clients: this.$store.getters.clients,
      singleClient: false,
      columns: ['nomeFantasia'],
      options: {
        columnsClasses: { 'nomeFantasia': 'col-md-11' },
        headings: {
          nomeFantasia: this.$t('modalCliente.labels.nome')
        },
        filterable: false,
        perPageValues: [],
        texts: {
          count: '',
          noResults: this.$t('dataTable.labels.semResultados')
        },
        sortIcon: {
          is: ''
        },
        sortable: ['nomeFantasia'],
        pagination: { chunk: 5 },
        customSorting: {
          nomeFantasia: function (ascending) {
            return function (a, b) {
              return customSorter.stringSorter(ascending, a, b, 'nomeFantasia')
            }
          }
        }
      }
    }
  },

  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    },
    client () {
      return this.$store.getters.client
    },
    openClientModal () {
      return this.$store.getters.openClientModal
    },
    updateLocation () {
      return this.$store.getters.updateLocation
    },
    lastUrl () {
      return this.$store.getters.lastUrl
    }
  },

  watch: {
    openClientModal () {
      if (this.isLoggedIn) {
        this.loadClients()
      }
    }
  },

  methods: {
    loadClients () {
      if (this.clients.length > 1) {
        this.singleClient = false
        this.showModal()
      } else if (this.clients.length === 1) {
        this.singleClient = true
        this.selectClient(this.clients[0].id, this.clients[0].nomeFantasia)
      }
    },

    selectClient (id, name) {
      this.$store.dispatch('cleanFunctionatieModule').then(() => {
        this.$store.dispatch('setClient', { client: id, clientName: name, singleClient: this.singleClient }).then((response) => {
          $('#client-modal').modal('hide')
          this.$store.dispatch('getFuncionalities').then((response) => {
            this.$store.dispatch('saveAllowedFuncionalities', response.data.allowedFunc).then((response) => {
              $('#client-modal').modal('hide')
              this.$store.dispatch('cleanGadgetsFilters')
              localStorage.setItem('event-client-selected', Math.random())
              if (this.updateLocation) {
                this.$router.push(this.lastUrl)
                this.$store.dispatch('setUpdateLocation', false)
                this.$store.dispatch('setLastUrl', null)
              } else {
                this.$router.push(PATHS.HOME)
              }
            })
          })
        })
      })
    },

    closeModal () {
      if (this.client) $('#client-modal').modal('hide')
    },

    showModal () {
      if (!this.client) {
        $('#client-modal').modal({
          backdrop: 'static',
          keyboard: false
        })
      } else {
        $('#client-modal').modal()
      }
    },

    rowClick (props) {
      this.selectClient(props.row.id, props.row.nomeFantasia)
    }
  },

  mounted () {
    if (this.isLoggedIn && !this.client && this.autoOpen) {
      this.loadClients()
    }
  }
}
</script>

<style lang='css'>
.page-title {
  color: #1d436a;
  padding-left: 5px;
}

.page-title h1 {
  font-family: 'Inter', sans-serif;
font-weight: 700;
  font-size: 2em;
  margin-bottom: 0px;
}

.page-title h4 {
  margin-top: 5px;
  margin-left: 2px;
}

.subtitle {
  font-family: 'Inter', sans-serif;
  font-size: 15px;
}

.modal-body {
  padding: 15px 15px 0px 15px !important;
}

.bg-selected {
  background: #1d436a;
  opacity: 0.3;
}

.bg-unselected {
  background: #fff;
}

.selector-selected {
  color: #1d436a;
  font-weight: bold;
  margin: 3px!important;
  cursor: pointer;
}

.selector-unselected {
  color: #9e9b9b;
  margin: 3px!important;
  cursor: pointer;
}

.selector-icon {
  margin-right: 0.5vw;
}

.modal-dialog {
  margin: auto auto;
}

.modal-center {
  display:table;
  height: 100%;
  width: 100%;
}

.modal.in .modal-dialog {
  display: table-cell;
  vertical-align: middle;
}

.modal-content {
  width:inherit;
  height:inherit;
  margin: 0 auto;
}

.select-client-table tbody > tr label {
  line-height: 100%;
}
</style>



// WEBPACK FOOTER //
// ClientModal.vue?0bf05d62